import onGetPatientNotificationRules from './onGetPatientNotificationRules';
import onCreatePatientNotificationRule from './onCreatePatientNotificationRule';
import onDeletePatientNotificationRule from './onDeletePatientNotificationRule';

export default {
  onGetPatientNotificationRules,
  onCreatePatientNotificationRule,
  onDeletePatientNotificationRule,
};
